import { Component, ViewChild, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

const valid_elements = [
  'a[href|target=_blank]',
  'strong/b',
  'div[align]',
  'br',
  'p',
  'ul',
  'li',
].join(',');

const defaultConfig = {
  base_url: '/tinymce',
  suffix: '.min',
  branding: false,
  menubar: false,
  plugins: [ 
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount'],
    toolbar: 'insert | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
  inline: false,
  valid_elements,
  height: 200,
};

@Component({
  selector: 'formly-tiny-type',
  styleUrls: ['./formly-tinymce.type.component.scss'],
  templateUrl: './formly-tinymce.type.component.html',

})
export class FormlyTinyMceTypeComponent extends FieldType implements OnInit {
  public config = { ...defaultConfig };

  ngOnInit() {
   // super.ngOnInit();
  }
}
